/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Provider_Eleven_LabsInputs */



/**
* | output |
* | --- |
* | "ElevenLabs" |
*
* @param {Voice_Manager_Provider_Eleven_LabsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_provider_eleven_labs = /** @type {((inputs?: Voice_Manager_Provider_Eleven_LabsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Provider_Eleven_LabsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("ElevenLabs")
	if (locale === "de") return /** @type {LocalizedString} */ ("ElevenLabs")
	if (locale === "it") return /** @type {LocalizedString} */ ("ElevenLabs")
	if (locale === "ru") return /** @type {LocalizedString} */ ("ElevenLabs")
	if (locale === "es") return /** @type {LocalizedString} */ ("OnceLabs")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("ElevenLabs")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イレブンラボ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इलेवनलैब्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("OnzeLabs")
	return /** @type {LocalizedString} */ ("ElevenLabs")
});